import { formatCurrency } from "../../../helpers/getSymbolFromCurrency";
import { getCtripCarType } from "./ctripCarTypes";
import { isAirportPickup } from "./utils";

export const RATE_TYPES = {
  DISTANCE: "distance_rate",
  FIXED: "fixed_rate",
};

const MOBIO_SERVICE_LEVEL_TO_CAR_TYPE = {
  Standard: "STANDARD",
  Carrier: "CARRIER",
  Executive: "EXECUTIVE",
  Luxury: "EXECUTIVE",
  "Large People Carrier": "LARGE_PEOPLE_CARRIER",
  "Mini bus": "MINI_BUS",
  "Executive People Carrier": "EXECUTIVE_PEOPLE_CARRIER",
  "Electric Luxury": "ELECTRIC_LUXURY",
};

export const getCarTypeFromMobioServiceLevel = (serviceLevelName) =>
  MOBIO_SERVICE_LEVEL_TO_CAR_TYPE[serviceLevelName] || null;

export const getPolygonsFromAirport = (airport) => {
  if (!airport?.fixedRates?.length) {
    return [];
  }

  const polygonMap = new Map();

  airport.fixedRates
    .filter((rate) => rate.status && rate.polygonId)
    .forEach((rate) => {
      if (!polygonMap.has(rate.polygonId)) {
        polygonMap.set(rate.polygonId, {
          id: rate.polygonId,
          name: rate.polygon?.name || rate.polygonId,
        });
      }
    });

  return Array.from(polygonMap.values());
};

export const findAirportByIata = (airports, iata) =>
  airports.find((airport) => airport.iata === iata) || null;

export const findMobioRateForOffer = ({
  airport,
  rateType,
  polygonId,
  carType,
  fromAirport,
}) => {
  if (!airport || !carType) {
    return null;
  }

  if (rateType === RATE_TYPES.DISTANCE) {
    return (
      (airport.distanceRates || []).find((rate) => {
        const rateCarType = getCarTypeFromMobioServiceLevel(
          rate.serviceLevel?.name
        );
        return rateCarType === carType;
      }) || null
    );
  }

  return (
    (airport.fixedRates || []).find((rate) => {
      const rateCarType = getCarTypeFromMobioServiceLevel(
        rate.serviceLevel?.name
      );
      return (
        // rate.status &&
        rateCarType === carType &&
        rate.polygonId === polygonId &&
        rate.fromAirport === fromAirport
      );
    }) || null
  );
};

export const formatMobioRateDescription = ({
  rateType,
  mobioRate,
  polygonId,
  currency,
}) => {
  if (!mobioRate) {
    return "Price is not set in integration";
  }

  if (rateType === RATE_TYPES.FIXED) {
    const polygonName = mobioRate.polygon?.name;
    const polygonLabel = polygonName ? ` · Polygon: ${polygonName}` : "";
    return `Fixed rate: ${formatCurrency(currency, mobioRate.rate)}${polygonLabel}`;
  }

  return `Distance rate: ${formatCurrency(
    currency,
    mobioRate.initialRate
  )} initial (${mobioRate.initialDistance} km), then ${formatCurrency(
    currency,
    mobioRate.pricePerKM
  )}/km`;
};

export const getMobioRateValue = (rateType, mobioRate) => {
  if (!mobioRate) {
    return null;
  }

  if (rateType === RATE_TYPES.FIXED) {
    return mobioRate.rate;
  }

  return mobioRate.initialRate;
};

export const resolveMobioRateContext = ({
  offer,
  fleetFilters,
  airportDetails,
  tripType,
  currency,
}) => {
  const carType = getCtripCarType(offer.categoryId);
  const airportCode =
    fleetFilters?.airportCode || airportDetails[0]?.iata || "";
  const rateType = fleetFilters?.rateType || RATE_TYPES.DISTANCE;
  const airport = findAirportByIata(airportDetails, airportCode);
  const fromAirport = isAirportPickup(tripType);
  const polygonId =
    rateType === RATE_TYPES.FIXED ? fleetFilters?.polygonId : null;

  const mobioRate = findMobioRateForOffer({
    airport,
    rateType,
    polygonId,
    carType,
    fromAirport,
  });

  return {
    carType,
    airportName: airport?.name || "",
    airportId: airport?.id || "",
    rateType,
    polygonId,
    fromAirport,
    mobioRate,
    mobioRateValue: getMobioRateValue(rateType, mobioRate),
    rateDescription: formatMobioRateDescription({
      rateType,
      mobioRate,
      polygonId,
      currency,
    }),
  };
};
